import React from "react"
import autosize from "autosize"

import ContactImage from "./images/ContactImage"

import "./Contact.scss"

function encode(data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&")
}

const Form = () => {
  const [email, setEmail] = React.useState("")
  const [name, setName] = React.useState("")
  const [mobile, setMobile] = React.useState("")
  const [message, setMessage] = React.useState("")
  React.useEffect(() => {
    autosize(document.querySelectorAll("textarea"))
  }, [])

  const [result, setResult] = React.useState(null)

  const formRef = React.createRef()
  const handleSubmit = e => {
    e.preventDefault()

    if (!formRef.current.checkValidity()) return false

    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({
        "form-name": formRef.current.getAttribute("name"),
        email, name, mobile, message,
      })
    })
      .then(() => setResult('success'))
      .catch(error => setResult('fail'))
  }

  let props = {
    name: 'contact',
    ref: formRef,
    onSubmit: handleSubmit,
    'data-netlify': 'true',
    'data-netlify-honeypot': 'bot-field',
  }

  if (result === 'success') {
    return (
      <div className="form">
        <p>Thanks for getting in contact with us.<br /> A member of our team will be in touch soon.</p>
      </div>
    )
  }

  return (
    <div className="form">
      <form {...props}>
        <input
          className="form__input"
          type="text"
          name="name"
          placeholder="Your Name"
          onChange={(e) => {
            setName(e.target.value)
          }}
          required
        />
        <input 
          className="form__input" 
          type="email" 
          name="email" 
          placeholder="Email" 
          onChange={(e) => {
            setEmail(e.target.value)
          }}
          required 
        />
        <input
          className="form__input"
          type="text"
          name="mobile"
          onChange={(e) => {
            setMobile(e.target.value)
          }}
          placeholder="Mobile"
        />
        <textarea
          className="form__input__enquiry"
          name="message"
          onChange={(e) => {
            setMessage(e.target.value)
          }}
          placeholder="Enquiry"
        />
        <button className="form__button">Send Enquiry</button>
      </form>
    </div>
  )
}


const Contact = (props) => {
  return (
    <section className="contact">
      <div className="contact__container">
        <div className="contact__container__left">
          <div className="contact__container__left__text" dangerouslySetInnerHTML={{ __html: props.content }} />
          <div className="contact__container__left__image">
            <ContactImage />
          </div>
        </div>
        <div className="contact__container__form">
          <Form />
        </div>
      </div>
    </section>
  )
}

export default Contact
